module.exports = __webpack_public_path__ + "img/c10.08ac263a.png";